import React from 'react'
import './About.css'
import {S1_about} from './S1_about'
import S2_about from './S2_about'
import {S3_about} from './S3_about'
import S7_Home from '../Home/S7_Home'

const Main_about = () => {
  return (
    <div>
      <S1_about/>
      <S2_about/>
      <S3_about/>
      <S7_Home/>
    </div>
  )
}

export default Main_about